import React from 'react';

const Skill = ({ title, Logo }) => {
    return (
        <div className='sm:mx-1 md:mx-4 lg:mx-6 xl:mx-9 cursor-pointer w-40 skill'>
            <div className='skill_img w-20 h-20 md:w-35 md:h-35 lg:w-38 lg:h-38 2xl:w-40 2xl:h-40 m-auto'>
                <img src={Logo} alt="JavaScript" />
            </div>
            <h1 className='mt-3 text-center text-xl md:text-2xl'>{title}</h1>
        </div>
    );
};

export default Skill;